import { render, staticRenderFns } from "./SubmitDialog.vue?vue&type=template&id=7a51c226&scoped=true&"
import script from "./SubmitDialog.vue?vue&type=script&lang=js&"
export * from "./SubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDialog.vue?vue&type=style&index=0&id=7a51c226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51c226",
  null
  
)

export default component.exports